var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["BancontactCard"] = "bancontactCard";
  PaymentMethod2["BancontactMobile"] = "bancontactMobile";
  PaymentMethod2["CashOnDelivery"] = "cashOnDelivery";
  PaymentMethod2["Creditcard"] = "creditcard";
  PaymentMethod2["Fake"] = "fake";
  PaymentMethod2["Ideal"] = "ideal";
  PaymentMethod2["Klarna"] = "klarna";
  PaymentMethod2["KlarnaAccount"] = "klarna_account";
  PaymentMethod2["MBway"] = "mbway";
  PaymentMethod2["MobilePay"] = "mobilepay";
  PaymentMethod2["Multibanco"] = "multibanco";
  PaymentMethod2["Oney"] = "oney";
  PaymentMethod2["Paypal"] = "paypal";
  PaymentMethod2["SepaDirectDebit"] = "sepadirectdebit";
  PaymentMethod2["Swish"] = "swish";
  PaymentMethod2["ApplePay"] = "applepay";
  PaymentMethod2["GooglePay"] = "googlepay";
  PaymentMethod2["Bizum"] = "bizum";
  PaymentMethod2["Twint"] = "twint";
  PaymentMethod2["Invoice"] = "invoice";
  return PaymentMethod2;
})(PaymentMethod || {});
var PaymentServiceProvider = /* @__PURE__ */ ((PaymentServiceProvider2) => {
  PaymentServiceProvider2["Adyen"] = "adyen";
  PaymentServiceProvider2["Fake"] = "fake";
  PaymentServiceProvider2["CashOnDelivery"] = "cashOnDelivery";
  PaymentServiceProvider2["MFGROUP"] = "mfgroup";
  return PaymentServiceProvider2;
})(PaymentServiceProvider || {});
var PaymentResult = /* @__PURE__ */ ((PaymentResult2) => {
  PaymentResult2["Success"] = "success";
  PaymentResult2["Approved"] = "approved";
  PaymentResult2["Pending"] = "pending";
  PaymentResult2["Failed"] = "failed";
  PaymentResult2["Redirect"] = "redirect";
  PaymentResult2["Error"] = "error";
  PaymentResult2["Cancelled"] = "cancelled";
  PaymentResult2["Refused"] = "refused";
  PaymentResult2["InternalError"] = "internal-error";
  PaymentResult2["Received"] = "received";
  return PaymentResult2;
})(PaymentResult || {});
var CartState = /* @__PURE__ */ ((CartState2) => {
  CartState2["Active"] = "Active";
  CartState2["Merged"] = "Merged";
  CartState2["Ordered"] = "Ordered";
  return CartState2;
})(CartState || {});
var CallbackResultCode = /* @__PURE__ */ ((CallbackResultCode2) => {
  CallbackResultCode2["Authorised"] = "authorised";
  CallbackResultCode2["Cancelled"] = "cancelled";
  CallbackResultCode2["Refused"] = "refused";
  CallbackResultCode2["Pending"] = "pending";
  CallbackResultCode2["Received"] = "received";
  return CallbackResultCode2;
})(CallbackResultCode || {});
export {
  CallbackResultCode,
  CartState,
  PaymentMethod,
  PaymentResult,
  PaymentServiceProvider
};
//# sourceMappingURL=types.js.map
